import { useState } from 'react';
import { useAuthStore } from '@stores/authStore';
import { permissions } from '@utils/permissions';
import { SMSTemplates } from './settings/SMSTemplates';
import { CaseDispatchRules } from './settings/CaseDispatchRules';
import { UserManagement } from './settings/UserManagement';
import { Profile } from './settings/Profile';

type SettingsTab = 'profile' | 'sms_templates' | 'dispatch_rules' | 'user_management';

export const Settings = () => {
  const { user } = useAuthStore();
  const [activeTab, setActiveTab] = useState<SettingsTab>('profile');

  if (!user) return null;

  const tabs = [
    { id: 'profile', label: 'Profile', icon: '👤' },
    { id: 'sms_templates', label: 'SMS Templates', icon: '📱', requiredPermission: permissions.canSendSMS },
    { id: 'dispatch_rules', label: 'Case Dispatch Rules', icon: '⚙️', requiredPermission: permissions.isOperationsOrAdmin },
    { id: 'user_management', label: 'User Management', icon: '👥', requiredPermission: permissions.canManageStaff },
  ].filter(tab => !tab.requiredPermission || tab.requiredPermission(user));

  return (
    <div>
      <h1 className="page-title">Settings</h1>
      <p className="page-subtitle">System configuration and preferences</p>

      <div className="tab-navigation" style={{ marginTop: 'var(--spacing-xxl)' }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'tab-button-active' : ''}`}
            onClick={() => setActiveTab(tab.id as SettingsTab)}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-content" style={{ marginTop: 'var(--spacing-xxl)' }}>
        {activeTab === 'profile' && <Profile />}
        {activeTab === 'sms_templates' && <SMSTemplates />}
        {activeTab === 'dispatch_rules' && <CaseDispatchRules />}
        {activeTab === 'user_management' && <UserManagement />}
      </div>
    </div>
  );
};

